const IMAGE_ONLY_PARAGRAPH_CLASS = 'ql-image-only-paragraph';
const BEFORE_CUSTOM_HR_CLASS = 'ql-before-custom-hr';

const isImageOnlyParagraph = (paragraph: HTMLParagraphElement): boolean => {
  let hasImage = false;

  for (const node of Array.from(paragraph.childNodes)) {
    if (node.nodeType === Node.TEXT_NODE) {
      if ((node.textContent || '').trim()) return false;
      continue;
    }

    if (node.nodeType !== Node.ELEMENT_NODE) return false;
    const tagName = (node as HTMLElement).tagName.toLowerCase();
    if (tagName === 'img') {
      hasImage = true;
      continue;
    }
    if (tagName === 'br') continue;
    return false;
  }

  return hasImage;
};

const isBeforeCustomHr = (paragraph: HTMLParagraphElement): boolean => {
  const nextElement = paragraph.nextElementSibling as HTMLElement | null;
  if (!nextElement) return false;
  if (nextElement.tagName.toLowerCase() !== 'hr') return false;
  if (!nextElement.classList.contains('custom-hr-block')) return false;

  if (!paragraph.childNodes.length) return true;

  for (const node of Array.from(paragraph.childNodes)) {
    if (node.nodeType === Node.TEXT_NODE) {
      if ((node.textContent || '').trim()) return false;
      continue;
    }

    if (node.nodeType !== Node.ELEMENT_NODE) return false;
    const tagName = (node as HTMLElement).tagName.toLowerCase();
    if (tagName !== 'br') return false;
  }

  return true;
};

export const syncQuillParagraphClasses = (root: HTMLElement) => {
  const paragraphs = root.querySelectorAll('p');

  paragraphs.forEach((node) => {
    const paragraph = node as HTMLParagraphElement;
    paragraph.classList.toggle(
      IMAGE_ONLY_PARAGRAPH_CLASS,
      isImageOnlyParagraph(paragraph),
    );
    paragraph.classList.toggle(
      BEFORE_CUSTOM_HR_CLASS,
      isBeforeCustomHr(paragraph),
    );
  });
};

